import { useQuery, UseQueryResult } from "react-query";
import { ContentHttpService } from "../services";

export interface Report {
  id: number;
  created_at: string;
  updated_at: string;
  sort_order: number;
  topic: string;
  query: string;
  generated_report: string;
}

function useReport(id: any | undefined): UseQueryResult<any, unknown> {
  return useQuery<any, unknown>(
    ["report", id],
    () => ContentHttpService.loadReport(id),
    {
      enabled: !!id,
      onSuccess: (data) => {
        // console.log("Loaded Report:", data);
      },
    }
  );
}

export default useReport; 